import { Injectable } from '@angular/core';
import {BaseService} from "@core/service/base.service";
import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {Observable} from "rxjs/index";
import {catchError, tap} from "rxjs/operators";
export const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
  withCredentials: true,
};
@Injectable({
  providedIn: 'root'
})
export class BrowserCommonsService extends BaseService{

  constructor(http:HttpClient) {
    super(http);
  }
  private url = '';
  getUrl():string{
    return this.url;
  }
  /** GET from the server */
  queryData(params:HttpParams,url):Observable<any> {
    return this.http.get(url,
      {
        headers: httpOptions.headers,
        observe: 'response',//完整数据返回，包括抬头
        params: params
      }
    ).pipe(
      tap(() => this.log('query object')),
      catchError(this.handleError('get any', []))
    );
  }
}
